import { atom } from 'recoil';

export const AllocationUpdateDataTypeAtom = atom<true | false>({
	key: 'updateData',
	default: false,
});
